import LegalLayout from "@/components/feature/LegalLayout";
import Seo from "@/components/feature/Seo";
import { buildBreadcrumbSchema } from "@/seo/schema";
import { SITE_URL } from "@/pages/home/constants";

const PAGE_URL = `${SITE_URL}politica-de-privacidade`;

export default function PrivacyPolicy() {
  return (
    <>
      <Seo
        title="Política de Privacidade | Eco Tour Turismo Capitólio"
        description="Sua privacidade em primeiro lugar: veja como a Eco Tour Turismo protege seus dados ao reservar passeios de lancha em Capitólio, com segurança e transparência."
        keywords="política de privacidade, Eco Tour Turismo, passeio de lancha em Capitólio"
        canonical={PAGE_URL}
        jsonLd={buildBreadcrumbSchema([
          { name: "Início", url: SITE_URL },
          { name: "Política de Privacidade", url: PAGE_URL },
        ])}
      />
      <LegalLayout title="Política de Privacidade" updatedAt="Outubro de 2026">
        <section>
          <h2 className="font-heading text-base font-bold text-primary-900 mb-2">1. Informações que coletamos</h2>
          <p>
            A Eco Tour Turismo coleta apenas as informações necessárias para o atendimento e a reserva dos
            passeios de lancha em Capitólio, como nome, telefone e mensagens enviadas por WhatsApp. Não
            solicitamos dados sensíveis para navegar em nosso site.
          </p>
        </section>
        <section>
          <h2 className="font-heading text-base font-bold text-primary-900 mb-2">2. Uso das informações</h2>
          <p>
            Utilizamos os seus dados exclusivamente para responder às suas solicitações, confirmar reservas e
            enviar informações relevantes sobre os passeios de lancha em Capitólio. Nunca vendemos ou
            compartilhamos seus dados com terceiros para fins publicitários.
          </p>
        </section>
        <section>
          <h2 className="font-heading text-base font-bold text-primary-900 mb-2">3. Cookies</h2>
          <p>
            Usamos cookies para melhorar sua experiência de navegação, analisar o tráfego do site e
            personalizar conteúdos. Você pode gerenciar ou recusar cookies nas configurações do seu navegador
            a qualquer momento.
          </p>
        </section>
        <section>
          <h2 className="font-heading text-base font-bold text-primary-900 mb-2">4. Seus direitos</h2>
          <p>
            Você tem o direito de solicitar a visualização, correção ou exclusão dos seus dados pessoais. Para
            isso, basta entrar em contato com a nossa equipe pelos canais oficiais de atendimento.
          </p>
        </section>
        <section>
          <h2 className="font-heading text-base font-bold text-primary-900 mb-2">5. Segurança</h2>
          <p>
            Adotamos medidas técnicas e organizacionais adequadas para proteger as suas informações contra
            acessos não autorizados, perdas ou alterações.
          </p>
        </section>
      </LegalLayout>
    </>
  );
}